import {
  areYouSureDescLabel,
  areYouSureLabel,
  closeLabel,
  deleteLabel,
} from "Components/constants/Common";
import { DeleteLabel, submitLabel, YesLabel } from "Components/constants/Role";
import PropTypes from "prop-types";
import { Modal, ModalBody, ModalHeader, Spinner } from "reactstrap";

interface DeleteModalProps {
  btnLoader: boolean;
  onCloseClick: () => void;
  onDeleteClick: () => void;
  show: boolean;
}

const DeleteModal: React.FC<DeleteModalProps> = ({
  btnLoader,
  onCloseClick,
  onDeleteClick,
  show,
}) => {
  return (
    <Modal
      isOpen={show}
      toggle={onCloseClick}
      centered={true}
      className="w-400"
    >
      <ModalHeader toggle={onCloseClick} className="border-bottom pb-2">
        {DeleteLabel}
      </ModalHeader>
      <ModalBody className="py-3 px-2">
        <div className="mt-2 text-start">
          <div className="fs-6 mx-3">
            <p className="mb-0">{areYouSureDescLabel}</p>
          </div>
        </div>
        <div className="d-flex gap-2 justify-content-end mt-4 mb-2 me-3">
          <button
            type="button"
            className="btn btn-success"
            id="delete-record"
            disabled={btnLoader}
            onClick={onDeleteClick}
          >
            {btnLoader ? (
              <>
                <Spinner size="sm" /> Loading...
              </>
            ) : (
              submitLabel
            )}
          </button>
          <button
            type="button"
            className="btn btn-danger"
            data-bs-dismiss="modal"
            onClick={onCloseClick}
          >
            {closeLabel}
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default DeleteModal;
